export default __webpack_public_path__ + "static/media/right-arrow-white.61565103.svg";